import { useEffect, useState } from "react";
import { ManageProducts, ManageRestaurant } from "../../Functionalities/Functions";
import { productRows } from "../../Functionalities/productSearch";

const franchiseFilter = (franchiseId) => (franchiseId ? `&franchise_list=[${franchiseId}]` : "");

function useLoaded(load, deps) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    setRows([]);
    const request = load();
    if (!request) return undefined;
    let current = true;
    request
      .then((result) => current && setRows(productRows(result && result.data)))
      .catch(() => current && setRows([]));
    return () => {
      current = false;
    };
  }, deps);
  return rows;
}

export const useRestaurants = (open, franchiseId) =>
  useLoaded(
    () => open && ManageRestaurant("", "", "get", `for_dropdown=true&page_wise=false&order_by_name=true${franchiseFilter(franchiseId)}`),
    [open, franchiseId],
  );

export const useRestaurantProducts = (restaurantId) =>
  useLoaded(
    () => restaurantId && ManageProducts("", "", "get", `for_dropdown=true&order_by_name=true&page_wise=false&branch_id=${restaurantId}`),
    [restaurantId],
  );
